import { Routes, Route, Navigate } from "react-router-dom";

import { Layout } from "@/components/layout";
import { ProtectedRoute } from "@/components/protected-route";
import PageNotFoundPage from "@/pages/page-not-found-page";
import { LoginPage } from "@/pages/login-page";
import { TimelinePage } from "@/pages/timeline-page";
import { IndividualsPage } from "@/pages/individuals-page";
import { ProjectsPage } from "@/pages/projects-page";
import { routes } from "@/routes";

export const AppRoutes = () => (
    <Routes>
        <Route path={routes.login.path} element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
                <Route index element={<Navigate to={routes.timeline.path} replace />} />
                <Route path={routes.timeline.path} element={<TimelinePage />} />
                <Route path="/departments" element={<Navigate to={routes.individuals.path} replace />} />
                <Route path={routes.individuals.path} element={<IndividualsPage />} />
                <Route path={routes.projects.path} element={<ProjectsPage />} />
                <Route path="*" element={<PageNotFoundPage />} />
            </Route>
        </Route>
    </Routes>
);
